import { isUserLoggedIn } from 'redux/modules/sessions/selectors';
import {
  Fetcher,
  FetcherArgs,
  PreloadOnlyFetcher,
  PreloadOnlyFetcherArgs,
} from 'route-data/fetcher-types';
import { redirectToLogin } from 'utils/login';

export function redirectIfLoggedOut<PathParamKey extends string = string>():
  | Fetcher<PathParamKey>
  | PreloadOnlyFetcher {
  return (args: FetcherArgs<PathParamKey> | PreloadOnlyFetcherArgs) => {
    if ('preloadOnly' in args) {
      return () => undefined;
    }

    return (_: WtrDispatch, getState: WtrGetState) => {
      if (!isUserLoggedIn(getState())) {
        redirectToLogin();
        // we never resolve this promise because we redirect the user to login screen
        // and we don't want to continue with the fetcher chain
        return new Promise(() => {});
      }
      return Promise.resolve();
    };
  };
}
